import React, { useContext, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';

import { Container, Grid, LinearProgress } from '@mui/material';
import { PageHeader } from '../../common';
import { NavContext, FetchContext } from '../../contexts';
import { ImpostazioneDetailsForm } from './components';
import { ImpostazioneContext, ImpostazioneProvider } from './ImpostazioneContext';

const PageContent = (props) => {

    const {
        user
    } = useContext(FetchContext);

    const {
        addBreadcrumbToken,
        setBread,
        goBack,
    } = useContext(NavContext);

    const {
        state,
        setState,

        isLoadingImpostazione,
        getImpostazioneAsync,

        isUpdatingImpostazione,
        updateImpostazioneAsync,
    } = useContext(ImpostazioneContext)

    const {
        impostazione,
    } = state;

    const {
        impostazioneId,
    } = useParams();

    const formRef = useRef();
    const saveClickHandler = () => {
        if (formRef.current) {
            formRef.current.handleSubmit();
        }
    }

    const impostazioneDetailsFormActionClickHandler = async (action, data) => {
        switch (action) {
            case "Submit":
                if (impostazione) {
                    await updateImpostazioneAsync(data);
                }
                break;
            default:
                break;
        }
    }

    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        setIsLoading(isLoadingImpostazione || isUpdatingImpostazione);
    }, [isLoadingImpostazione, isUpdatingImpostazione])

    useEffect(() => {
        if(user){
            addBreadcrumbToken("Impostazioni");
            getImpostazioneAsync();
        }
    }, [user]);

    if(!user)
        <Container>
            <LinearProgress/>
        </Container>

    return (
        <>
            <Container>
                {isLoading && <LinearProgress />}
                <Grid container>
                    <Grid item xs={12}>
                        <PageHeader
                            save
                            onSaveClick={saveClickHandler}
                            disabled={isLoading}
                            title="Impostazioni"
                            subtitle="Gestisci le impostazioni" />
                    </Grid>
                    <Grid item xs={12}>
                        <ImpostazioneDetailsForm
                            onActionClick={impostazioneDetailsFormActionClickHandler}
                            disabled={isLoading}
                            formRef={formRef} />
                    </Grid>
                </Grid>
            </Container>
        </>
    );
}

export const ImpostazionePage = () => {

    return (
        <ImpostazioneProvider>
            <PageContent />
        </ImpostazioneProvider>
    );
}